export const LOCAL_STORAGE_THEME_KEY = 'theme';
